module.exports = __webpack_public_path__ + "static/media/nasdaq.3decf04e.png";